import styled from 'styled-components';
import Image from 'next/image';

export const DesktopPromotionWrapper = styled.div`
  width: 440px;
  height: 39px;
  display: flex;
  padding: 8px;
  align-items: center;
  gap: 4px;
  align-self: stretch;
  border-radius: 8px;
  outline: solid 1px ${({ theme }) => theme.palette.NL40};
`;

export const DesktopPromotionDisplayItemWrapper = styled.div`
  display: flex;
  align-items: center;
  flex: 1 0 0;
  gap: 5px;
`;

export const LogoWrapper = styled.div<{ promotionLogo?: boolean }>`
  width: ${({ promotionLogo }) => (promotionLogo ? '16px' : '74px')};
  height: 16px;
  position: relative;
`;

export const StyledImage = styled(Image)`
  object-fit: contain;
  object-position: left;
`;

export const PromotionNameWrapper = styled.div`
  display: flex;
  align-items: center;
  flex: 1 0 0;
  gap: 3px;
`;

export const PromotionNameContainer = styled.div``;

export const ShowMoreContainer = styled.div`
  background-color: ${({ theme }) => theme.palette.NL30};
  border-radius: 4px;
  display: flex;
  padding: 4px;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  line-height: 13px;
  height: 23px;
`;

export const TooltipBodyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  max-height: 178px;
  overflow: scroll;
`;

export const TooltipItemWrapper = styled.div`
  display: flex;
  padding: 4px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  align-self: stretch;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.palette.NL20};
`;

export const MobilePromotionsWrapper = styled.div`
  display: flex;
  padding: 8px;
  align-items: center;
  align-self: stretch;
  border-radius: 8px;
  outline: solid 1px ${({ theme }) => theme.palette.NL40};
  margin-top: 6px;
  justify-content: space-between;
`;

export const MobilePromotionsDescriptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 8px;
`;

export const MobilePromotionNameWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 3px;
  min-height: 16px;
`;
